import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { ITLeasingBenefitListItemExtension } from './it-leasing-benefit-list-item.extension';
import { ITLeasingBenefitMetadataExtension } from './it-leasing-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('it-leasing')
    .add(BenefitMetadataExtensionInterface, new ITLeasingBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new ITLeasingBenefitListItemExtension())
    .build(),
);
